import type { ComponentProps } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { GooglePlacesProvider } from '#src/app/shared/hooks/googlePlaces';

import { ComboBox } from './components/Combobox';
import { useLocationField } from './hooks/useLocationField';

type LocationFieldProps = {
	errorMessage?: string | null;
	onChange?: ComponentProps<typeof ComboBox>['onChange'];
};

const LocationFieldBase: React.FC<LocationFieldProps> = ({ errorMessage, onChange }) => {
	const { data, actions } = useLocationField();
	const { translate } = useI18n();

	return (
		<>
			<ComboBox
				id="location"
				name="location"
				label={translate('corgi.start_a_petition.location.location_input_label')}
				inputValue={data.placeInputValue}
				onInputChange={(_, newValue) => {
					actions.handlePlaceInputChange(newValue);
				}}
				value={data.placeValue}
				onChange={(_, newValue) => {
					actions.handlePlaceChange(newValue);
					onChange?.(_, newValue);
				}}
				options={data.places}
				filterOptions={() => data.places}
				optionToString={(place) => place.name}
				renderOption={(option) => (
					<div className="flex items-center space-x-2">
						<span>{option.name}</span>
					</div>
				)}
				error={errorMessage}
				data-qa="location-step-combobox"
			/>
			{/* eslint-disable-next-line @change-corgi/require-data-qa-attribute */}
			<input type="hidden" name="locationName" data-testid="locationName" value={data.placeValue?.name || ''} />
			{/* eslint-disable-next-line @change-corgi/require-data-qa-attribute */}
			<input type="hidden" name="locationId" data-testid="locationId" value={data.placeValue?.id || ''} />
		</>
	);
};

export const LocationField: React.FC<LocationFieldProps> = ({ errorMessage, onChange }) => {
	return (
		<GooglePlacesProvider>
			{/* eslint-disable-next-line @change-corgi/require-data-qa-attribute */}
			<LocationFieldBase errorMessage={errorMessage} onChange={onChange} />
		</GooglePlacesProvider>
	);
};
